/**
 * The phone beside the hero, showing tonight's menu.
 *
 * Decorative: the wrapper is aria-hidden and the hero's own copy carries the
 * meaning. A screen reader reading out six fictional cocktails adds noise.
 *
 * Two brand rules are visible here. The row numbers and the ABV are Caveat —
 * asides and values, which is exactly what Caveat is for — and the ABV is one
 * of the three places blush is allowed. The dividers are ink at an alpha
 * rather than a hex, so they hold in both themes.
 */
import styles from './PhoneMenu.module.css';

export interface MenuRow {
  no: string;
  name: string;
  spec: string;
  abv: string;
  family: string;
}

interface PhoneMenuProps {
  time: string;
  handLabel: string;
  title: string;
  pourable: string;
  byFamily: string;
  rows: MenuRow[];
  tabs: string[];
}

export function PhoneMenu({
  time,
  handLabel,
  title,
  pourable,
  byFamily,
  rows,
  tabs,
}: PhoneMenuProps) {
  return (
    <div className={styles.frame} aria-hidden="true">
      <div className={styles.screen}>
        <div className={styles.statusBar}>
          <span>{time}</span>
          <span className={styles.battery} />
        </div>

        <div className={styles.head}>
          <span className={`hand ${styles.handLabel}`}>{handLabel}</span>
          <span className={styles.title}>{title}</span>
          <span className={styles.rule} />
          <span className={styles.meta}>
            <span>{pourable}</span>
            <span>{byFamily}</span>
          </span>
        </div>

        <div className={styles.list}>
          {rows.map((row) => (
            <div key={row.no} className={styles.row}>
              <span className={`hand ${styles.no}`}>{row.no}</span>
              <span className={styles.rowBody}>
                <span className={styles.name}>{row.name}</span>
                <span className={styles.spec}>{row.spec}</span>
              </span>
              <span className={styles.rowRight}>
                <span className={`hand ${styles.abv}`}>{row.abv}%</span>
                <span className={styles.family}>{row.family}</span>
              </span>
            </div>
          ))}
        </div>

        <div className={styles.tabs}>
          {tabs.map((label, i) => (
            <span key={label} className={styles.tab}>
              {/* The active tab dot — the third and last place blush appears. */}
              <span className={`${styles.dot} ${i === 0 ? styles.dotOn : ''}`} />
              <span className={`${styles.tabLabel} ${i === 0 ? styles.tabLabelOn : ''}`}>
                {label}
              </span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
